
<template>
  <svg width="6" height="3" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.41675 -5.24521e-06L2.70841 2.70833L8.10623e-05 -5.24521e-06L5.41675 -5.24521e-06Z" fill="black"/>
  </svg>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class DropDownIcon extends Vue {}
</script>
